// components/house/HouseMainImage.js
import React from 'react';
import { Card } from 'react-bootstrap';
import utils from '../../../helpers/utils';

const HouseMainImage = ({ house, className }) => {
  const imageUrl = house?.mainImage
    ? utils.defaultUrl() + house.mainImage.filePath
    : '';

  return (
    <Card.Img
      loading={'lazy'}
      src={imageUrl}
      alt={house?.name || 'Domek'}
      className={`image-1x1 ${className}`}
    />
  );
};

export default HouseMainImage;
